// extracted by mini-css-extract-plugin
module.exports = {"header":"Title_header__SIloF","skeleton":"Title_skeleton__mVs6k","skeleton-rect":"Title_skeleton-rect__IqyHc"};